export default {
    usua_login : '',
    perf_codigo : 0,
    orga_codigo : 0,
    usua_nome : '', //max 100
    usua_tipo : 'U', //TipoUsuarioEnum
    usua_senha : '', //max 20 
    usua_parametro1 : '',
    usua_parametro2 : '',
    usua_parametro3 : '',
    usua_parametro4 : '',
    usua_parametro5 : '',
    usua_parametro6 : '',
    usua_parametro7 : '',
    usua_parametro8 : '',
    usua_status : 0, //StatusEnum
    usua_cont_senha_errada : 0,
    poco_codigo : '',//max 10
    usua_email : '',//max 255
    usua_recebe_email : 'N',
    orga_codigo_aux : 0,
    usua_cpf : '',//11
    usua_consulta_controla_agenda : 0,
    usua_aprova_pre_faturamento : 'N',
    fadi_codigo : 0,
    //perf_tipo : 0, //Tipo do perfil    
    usuarioPostoVO : [],    
    unidadeUsuarioVO : [],

};
